/* eslint-disable no-console */
/* eslint-disable camelcase */
/* eslint-disable no-undef */
import Helpers from '../helpers';
import Config from '../helpers/configs';

/**
 * Page: Settings.
 * @param label
 */
const isEmpty = ( label ) => {
	return ( '' === label || null === label || 'undefined' === label ) ? true : false;
};

/**
 * Displays the Notice.
 *
 * @param {Object} args
 *
 * @return {string} Notice ID.
 */
const openNotice = ( args ) => {
	if ( ! ( 'message' in args ) || isEmpty( args.message ) ) {
		// Message must be set and mustn't be empty.
		console.error( 'Cannot display a notice without message' );
		return;
	}

	let icon_class = '';

	switch ( args.type ) {
		case 'success':
			icon_class = 'check-tick';
			break;

		case 'error':
		case 'warning':
			icon_class = 'warning-alert';
			break;

		case 'info':
		default:
			icon_class = 'info';
			break;
	}

	const options = {
		icon: icon_class,
		type: args.type
	};

	if ( args.dismissible ) {
		options.dismiss = { show: true };
	}

	if ( args.autoclose ) {
		options.autoclose = { timeout: args.autoclose };
	} else {
		options.autoclose = { show: false };
	}

	const $suiHeader = document.querySelector( '.sui-header' );
	const noticeId = 'snapshot-notice-' + Math.random().toString( 36 ).substr( 2, 9 );
	let $noticesWrapper = document.querySelector( '.sui-floating-notices' );
	const $notice = document.createElement( 'div' );

	if ( ! $noticesWrapper ) {
		$noticesWrapper = document.createElement( 'div' );
		$noticesWrapper.setAttribute( 'class', 'sui-floating-notices' );
	}
	$suiHeader.insertBefore( $noticesWrapper, $suiHeader.childNodes[ 0 ] );

	$notice.setAttribute( 'id', noticeId );
	$notice.setAttribute( 'role', 'alert' );
	$notice.setAttribute( 'aria-live', 'assertive' );
	$notice.setAttribute( 'class', 'sui-notice' );

	$noticesWrapper.appendChild( $notice );

	const noticeContent = `<p>${ args.message }</p>`;
	SUI.openNotice( noticeId, noticeContent, options );
	return noticeId;
};

/**
 * Activate the Configs tab.
 *
 * @return {boolean} Return true on success & false on failure.
 */
const activateConfigsTab = function() {
	const current = document.querySelector( '.sui-vertical-tab.current' );
	window.history.replaceState( '', document.title, snapshot_urls.settings );
	const passwordProtection = document.querySelector( '.snapshot-tab.snapshot-tab-password-protection' );

	if ( current ) {
		current.classList.remove( 'current' );

		document.querySelector( '.snapshot-vertical-configs' ).classList.add( 'current' );
		document.querySelector( '.snapshot-tab.snapshot-tab-api-key' ).style.display = 'none';

		if ( passwordProtection ) {
			passwordProtection.style.display = 'none';
		}
		document.querySelector( '.snapshot-tab.snapshot-tab-configs' ).style.display = 'block';
		return true;
	}
	return false;
};

const activateAuthenticationTab = function() {
	const current = document.querySelector( '.sui-vertical-tab.current' );
	window.history.replaceState( '', document.title, snapshot_urls.settings );
	const passwordProtection = document.querySelector( '.snapshot-tab.snapshot-tab-password-protection' );

	if ( current ) {
		current.classList.remove( 'current' );
		document.querySelector( '.snapshot-vertical-password-protection' ).classList.add( 'current' );

		document.querySelector( '.snapshot-tab.snapshot-tab-api-key' ).style.display = 'none';
		document.querySelector( '.snapshot-tab.snapshot-tab-configs' ).style.display = 'none';

		if ( passwordProtection ) {
			passwordProtection.style.display = 'block';
		}

		return true;
	}
	return false;
};

const urlHash = window.location.hash;
if ( urlHash ) {
	if ( '#apply-configs' === urlHash ) {
		activateConfigsTab();
	}

	if ( '#password-protection' === urlHash ) {
		activateAuthenticationTab();
	}
}

const urlSearchParams = new URLSearchParams( window.location.search );
if ( urlSearchParams.has( 'referer' ) && 'google_login' === urlSearchParams.get( 'referer' ) ) {
	const action = urlSearchParams.get( 'action' );
	if ( snapshotReact.requestsData.apiKey === urlSearchParams.get( 'set_apikey' ) ) {
		if ( action.indexOf( 'apply_config' ) >= 0 ) {
			const current = document.querySelector( '.snapshot-page-settings .sui-vertical-tabs .current' );

			if ( current ) {
				current.classList.remove( 'current' );
				document.querySelector( '.snapshot-vertical-configs' ).classList.add( 'current' );

				document.querySelector( '.snapshot-tab.snapshot-tab-api-key' ).style.display = 'none';
				document.querySelector( '.snapshot-tab.snapshot-tab-configs' ).style.display = 'block';
			}

			const config = action.split( 'apply_config_' );
			const config_id = parseInt( config[ 1 ] );

			const noticeId = openNotice( {
				type: 'info',
				dismissible: false,
				autoclose: false,
				message: snapshot_messages.applying_config,
			} );
			window.history.pushState( null, '', snapshot_urls.settings );

			const cfg = new Config();
			cfg.applyConfigAfterGoogleLogin( config_id, noticeId );
		}
	}
}

const fetching = false;

/**
 * Send the AJAX request to set "Get Started" seen
 */
const setSeen = () => {
	const nonce = snapshotReact.requestsData.pluginRequests.nonce;

	fetch( `${ ajaxurl }?action=snapshot_set_started_seen&_ajax_nonce=${ nonce }` )
		.then( ( response ) => response.json() )
		.then( ( data ) => data )
		.catch( ( err ) => {
			console.error( err );
		} );
};

const fetch_current_region = () => {
	let url = ajaxurl;
	url += '?action=snapshot_get_region';
	url += `&_ajax_nonce=${ snapshotReact.fetch_region_nonce }`;

	const xhr = new XMLHttpRequest();

	return new Promise( ( resolve, reject ) => {
		xhr.open( 'GET', url );
		xhr.onload = () => resolve( JSON.parse( xhr.responseText ) );
		xhr.onerror = () => reject( xhr.statusText );
		xhr.send( null );
	} );
};

/**
 * Confirm the config
 *
 * @param {Object} preset
 */

const config_confirm = ( preset ) => {
	if ( fetching ) {
		return;
	}

	const result = fetch_current_region();

	return new Promise( ( resolve, reject ) => {
		result.then( ( data ) => {
			let configs = preset.config.configs;
			configs = ( 'settings' in configs ) ? configs.settings : configs;

			if ( configs.region !== data.data.region ) {
				reject( {
					status: 'snapshot-region-mismatch',
					description: snapshotReact.region_mismatch_desc
				} );
			}

			resolve( {
				status: 'snapshot-region-match',
			} );
		} );
	} );
};

/**
 * Displays the WPMUDEV password modal.
 *
 * @param {string}         url
 * @param {Object}         data
 * @param {XMLHttpRequest} xhr
 */
const password_modal = ( url, data, xhr ) => {
	if ( url.indexOf( 'snapshot_apply_config' ) >= 0 ) {
		if ( xhr.readyState === 4 ) {
			const response = JSON.parse( xhr.responseText );
			if ( ! response.success ) {
				if ( 'password_required' === response.data.error ) {
					const passModal = document.querySelector( '#snapshot-confirm-wpmudev-password-modal' );
					passModal.querySelector( '[name=what]' ).value = 'apply_config_' + response.data.preset.id;

					SUI.openModal( 'snapshot-confirm-wpmudev-password-modal', window );

					const nonce = document.createElement( 'input' );
					nonce.setAttribute( 'type', 'hidden' );
					nonce.setAttribute( 'id', 'snapshot-confirm-password-nonce-field' );
					nonce.setAttribute( 'value', response.data._ajax_nonce );

					const preset = document.createElement( 'input' );
					preset.setAttribute( 'type', 'hidden' );
					preset.setAttribute( 'id', 'snapshot-apply-config-id' );
					preset.setAttribute( 'value', response.data.preset.id );

					passModal.querySelector( '.sui-form-field' ).appendChild( nonce );
					passModal.querySelector( '.sui-form-field' ).appendChild( preset );
				}
			}
		}
	}
};

window.snapshot_get_region_description = config_confirm;
window.snapshot_display_password_modal = password_modal;

let checking = false;
const submitPasswordForm = ( e ) => {
	e.preventDefault();
	if ( checking ) {
		return;
	}

	const form = e.target;
	const password = form.querySelector( '#snapshot-wpmudev-password' );

	if ( '' === password.value || null === password.value ) {
		password.closest( '.sui-form-field' ).classList.add( 'sui-form-field-error' );
		setTimeout( () => {
			form.querySelector( '#error-snapshot-wpmudev-password' ).style.display = 'block';
		}, 100 );
		password.focus();
		return;
	}
	password.closest( '.sui-form-field' ).classList.remove( 'sui-form-field-error' );
	form.querySelector( '#error-snapshot-wpmudev-password' ).style.display = 'none';

	checking = true;
	form.querySelector( '.submit-button' ).classList.add( 'sui-button-onload' );

	let nonce = '';
	let preset = '';

	if ( form ) {
		const nonceField = form.querySelector( '#snapshot-confirm-password-nonce-field' );
		const presetField = form.querySelector( '#snapshot-apply-config-id' );

		if ( nonceField && presetField ) {
			nonce = nonceField.value;
			preset = presetField.value;
		}
	}

	if ( '' === preset || '' === nonce ) {
		return;
	}

	const formData = new FormData();
	formData.append( 'action', 'snapshot_apply_config_confirm_wpmudev_password' );
	formData.append( 'password', password.value );
	formData.append( '_ajax_nonce', nonce );
	formData.append( 'id', preset );

	const request = fetch( ajaxurl, {
		method: 'POST',
		credentials: 'same-origin',
		body: formData,
	} );

	request
		.then( ( response ) => response.json() )
		.then( ( result ) => {
			if ( result.success ) {
				if ( ! result.data.password_is_valid ) {
					password.closest( '.sui-form-field' ).classList.add( 'sui-form-field-error' );
					form.querySelector( '#error-snapshot-wpmudev-password' ).style.display = 'block';
					password.value = '';
					password.focus();
					checking = false;
					form.querySelector( '.submit-button' ).classList.remove( 'sui-button-onload' );
				} else {
					// Send an additional request to apply the config if password is valid.
					const applyConfigFD = new FormData();
					applyConfigFD.append( 'action', 'snapshot_apply_config' );
					applyConfigFD.append( 'id', preset );
					applyConfigFD.append( '_ajax_nonce', nonce );

					const configRequest = fetch( ajaxurl, {
						method: 'POST',
						credentials: 'same-origin',
						body: applyConfigFD
					} );

					configRequest
						.then( ( response ) => response.json() )
						.then( ( res ) => {
							if ( res.success ) {
								// close the password modal.
								window.SUI.closeModal();

								let msg = snapshotReact.config_applied;
								msg = msg.replace( '{configName}', `<strong>${ res.data.name }</strong>` );
								const noticeArgs = {
									message: msg,
									type: 'success',
									dismissible: true
								};
								setSeen();
								openNotice( noticeArgs );
							}
						} )
						.catch( ( err ) => {
							window.console.err( err );
							// Display an error if something is wrong.
						} );
				}
			} else {
				form.querySelector( '.submit-button' ).classList.remove( 'sui-button-onload' );
				const modal = form.closest( '#snapshot-confirm-wpmudev-password-modal' );

				if ( result.data.code === 'invalid_login_method' ) {
					password.setAttribute( 'disabled', 'disabled' );
					password.classList.add( 'sui-disabled' );
					modal.querySelector( '.snapshot-login--method__error' ).classList.remove( 'd-none' );
					modal.querySelector( '.snapshot-login--method__error' ).querySelector( 'p' ).innerHTML = snapshot_messages.auth_method_invalid;
				} else {
					password.closest( '.sui-form-field' ).classList.add( 'sui-form-field-error' );
					form.querySelector( '#error-snapshot-wpmudev-password' ).style.display = 'block';
					password.value = '';
					password.focus();
					checking = false;
				}
			}
		} )
		.catch( ( err ) => {
			window.console.error( err );
		} );
};

const settingsPage = document.querySelector( '.snapshot-page-settings' );
const backupsPage = document.querySelector( '.snapshot-page-backups' );
const dashboardPage = document.querySelector( '.snapshot-page-dashboard' );
const destinationsPage = document.querySelector( '.snapshot-page-destinations' );
const hostingPage = document.querySelector( '.snapshot-page-hosting-backups' );

if ( settingsPage || dashboardPage || backupsPage || destinationsPage || hostingPage ) {
	const page = settingsPage || backupsPage || dashboardPage || destinationsPage || hostingPage;

	const modalForm = page.querySelector( '#snapshot-confirm-wpmudev-password-modal-form' );
	if ( modalForm ) {
		modalForm.addEventListener( 'submit', submitPasswordForm );
	}
}

/**
 * HTTP Authentication
 */
const authForm = document.querySelector( '#snapshot-auth-form' );
const url = window.location.href;
const retrieveAuthData = function() {
	const data = new FormData();
	data.append( 'action', 'snapshot_auth_retrieve' );
	data.append( '_ajax_nonce', SnapshotAjax.auth.nonce );

	return Helpers.request( data, 'GET' );
};

/**
 * Fills the authentication form with data.
 *
 * @param {Object|null} data Clears or fills the authentication form.
 */
const populateAuthForm = function( data ) {
	let http_user = '';
	let http_password = '';

	if ( null !== data ) {
		http_user = ( 'http_user' in data.creds ) ? data.creds.http_user : data.creds[ 0 ].http_user;
		http_password = ( 'http_password' in data.creds ) ? data.creds.http_password : data.creds[ 0 ].http_password;
	}

	if ( authForm ) {
		authForm.querySelector( '#auth_username' ).value = http_user;
		authForm.querySelector( '#auth_password' ).value = http_password;
	}
};

if ( url === snapshot_urls.settings && authForm ) {
	const data = retrieveAuthData();
	data.then( ( response ) => response.json() )
		.then( ( result ) => {
			if ( result.success ) {
				if ( ! authForm ) {
					return;
				}

				authForm.querySelector( '.sui-box-settings-row' ).classList.remove( 'sui-disabled' );

				if ( 'creds_not_found' === result.data.status ) {
					// Credentials not found.
					authForm.querySelector( '#auth_username' ).value = '';
					authForm.querySelector( '#auth_password' ).value = '';
					populateAuthForm( null );
				} else if ( 'creds_found' === result.data.status ) {
					populateAuthForm( result.data );
					authForm.querySelector( '#auth_method' ).value = 'put';
				}
			} else {
				// Failed on different cases.
				Helpers.Notice.open( {
					message: result.data.message,
					type: 'warning',
					dismissible: true
				} );
			}
		} )
		.catch( ( err ) => {
			console.error( err );
		} );
}

const authTestConnectionBtn = document.querySelector( '.btn-auth-test-connection' );
let saveAuthBtn = false;
if ( authForm ) {
	saveAuthBtn = authForm.querySelector( '.btn-save-auth-connection-details' );
}
let noticeId = null;

const authTestConnection = function( data ) {
	data.append( 'action', 'snapshot_auth_test_connection' );

	const request = Helpers.request( data, 'POST' );
	return request;
};

/**
 * Delete the authentication credentials.
 */
const deleteAuthCreds = function() {
	const fd = new FormData();
	fd.append( 'action', 'snapshot_auth_delete' );
	fd.append( '_ajax_nonce', SnapshotAjax.auth.nonce );

	const req = Helpers.request( fd, 'post' );
	return req;
};

if ( saveAuthBtn && authForm ) {
	saveAuthBtn.addEventListener( 'click', ( e ) => {
		e.preventDefault();

		const formData = new FormData( authForm );
		const username = formData.get( 'auth_username' );
		const password = formData.get( 'auth_password' );
		const method = formData.get( 'auth_method' );

		const fd = new FormData();
		fd.append( 'un', username );
		fd.append( 'pw', password );
		fd.append( '_ajax_nonce', SnapshotAjax.auth.nonce );

		const testConnection = authTestConnection( fd );

		saveAuthBtn.classList.add( 'sui-button-onload' );
		authTestConnectionBtn.classList.add( 'sui-button-onload' );
		testConnection.then( ( response ) => response.json() )
			.then( ( result ) => {
				if ( result.success ) {
					if ( result.data.connected ) {
						// Actually save the data now.
						fd.append( 'method', method );
						if ( fd.has( 'action' ) ) {
							fd.delete( 'action' );
						}
						fd.append( 'action', 'snapshot_auth_save' );

						const saveReq = Helpers.request( fd, 'POST' );
						saveReq.then( ( response ) => response.json() )
							.then( ( res ) => {
								saveAuthBtn.classList.remove( 'sui-button-onload' );
								authTestConnectionBtn.classList.remove( 'sui-button-onload' );
								saveAuthBtn.setAttribute( 'disabled', 'disabled' );
								if ( ! res.success ) {
									Helpers.Notice.open( {
										message: res.data.message,
										type: 'warning',
										dismissible: true,
									} );
									return;
								}

								const noticeData = {
									type: 'success',
									dismissible: false,
									autoclose: 3000,
									message: '',
								};

								if ( 'creds_stored' === result.data.status ) {
									noticeData.message = SnapshotAjax.auth.stored;
									populateAuthForm( result.data );
								} else if ( 'creds_updated' === result.data.status ) {
									noticeData.message = SnapshotAjax.auth.stored;
									populateAuthForm( result.data );
								} else if (
									'not_stored' === result.data.status ||
									'not_updated' === result.data.status
								) {
									noticeData.message = result.data.message;
								}

								Helpers.Notice.open( noticeData );
							} )
							.catch( ( err ) => {
								console.error( err );
							} );
					} else {
						// Test connection failed display error notice.
					}
				}
			} )
			.catch( ( err ) => {
				console.error( err );
			} );

		// const req = Helpers.request(data, 'POST');
	} );
}

if ( authTestConnectionBtn && authForm ) {
	authTestConnectionBtn.addEventListener( 'click', ( e ) => {
		e.preventDefault();
		const testData = new FormData( authForm );
		const el = e.target;
		el.classList.add( 'sui-button-onload' );

		const username = testData.get( 'auth_username' );
		const password = testData.get( 'auth_password' );

		const data = new FormData();
		data.append( 'un', username );
		data.append( 'pw', password );
		data.append( '_ajax_nonce', SnapshotAjax.auth.nonce );

		const req = authTestConnection( data );

		req
			.then( ( response ) => response.json() )
			.then( ( result ) => {
				el.classList.remove( 'sui-button-onload' );
				const args = {
					type: '',
					dismissible: false,
					autoclose: 0,
					message: ''
				};

				if ( result.success ) {
					args.type = 'success';
					args.dismissible = false;
					args.autoclose = 3000;
					args.message = SnapshotAjax.auth.succeed;

					if ( result.data.connected ) {
						// Enable the "Save Changes" button.
						saveAuthBtn.removeAttribute( 'disabled' );
					}

					if ( ! result.data.connected ) {
						saveAuthBtn.setAttribute( 'disabled', 'disabled' );
						args.type = 'error';
						args.autoclose = false;
						args.dismissible = true;
						args.message = SnapshotAjax.auth.failed;
					}

					if ( null !== noticeId ) {
						window.SUI.closeNotice( noticeId );
					}
				} else {
					args.type = 'error';
					args.dismissible = true;
					args.message = result.data.message;

					saveAuthBtn.setAttribute( 'disabled', 'disabled' );
				}

				if ( null !== noticeId ) {
					window.SUI.closeNotice( noticeId );
				}
				noticeId = openNotice( args );
			} )
			.catch( ( err ) => {
				console.error( err );
			} );
	} );
}

const deleteAuthCredsBtn = document.querySelector( '.btn-delete--http_creds' );
if ( deleteAuthCredsBtn ) {
	deleteAuthCredsBtn.addEventListener( 'click', function( e ) {
		e.preventDefault();
		deleteAuthCredsBtn.classList.add( 'sui-button-onload' );
		const response = deleteAuthCreds();

		response.then( ( data ) => data.json() )
			.then( ( result ) => {
				const notice = {
					dismissible: false,
					message: '',
					type: 'success',
					autoclose: false,
				};
				deleteAuthCredsBtn.classList.remove( 'sui-button-onload' );

				if ( result.success ) {
					populateAuthForm( null );
					notice.message = SnapshotAjax.auth.deleted;
					notice.autoclose = 3000;
				} else {
					notice.type = 'error',
					notice.dismissible = true;
					notice.message = snapshot_messages.general_error;
				}

				Helpers.Notice.open( notice );
			} )
			.catch( ( err ) => {
				console.error( err );
			} );
	} );
}

/**
 * ============ HTTP Authentication ============
 */

const setAuthNoticeSeen = function() {
	const noticeFd = new FormData();
	noticeFd.append( 'action', 'snapshot_auth_set_notice_seen' );
	noticeFd.append( '_ajax_nonce', SnapshotAjax.auth.nonce );

	const noticeReq = Helpers.request( noticeFd );
	noticeReq
		.then( ( response ) => response.json() )
		.then( ( result ) => {
			if ( ! result.success ) {

			}
		} )
		.catch( ( err ) => {
			console.error( err );
		} );
};

const checked = SnapshotAjax.auth.checked;
const isExternalHost = ! snapshot_env.values.has_hosting_backups;

if ( isExternalHost && ! checked ) {
	const authChecker = function() {
		let ajax_url = SnapshotAjax.ajaxurl;
		const nonce = SnapshotAjax.auth.nonce;
		ajax_url += `?action=snapshot_auth_check_protection&_ajax_nonce=${ nonce }`;
		const auth = fetch( ajax_url );
		auth.then( ( response ) => response.json() )
			.then( ( result ) => {
				if ( result.success ) {
					if ( 'auth_is_required' === result.data.status ) {
						if ( ! SnapshotAjax.auth.notified ) {
							openNotice( {
								id: 'auth_required_notice',
								type: 'error',
								dismissible: true,
								message: SnapshotAjax.auth.notice
							} );
							setAuthNoticeSeen();
						}
					}
				} else {

				}
			} )
			.catch( ( err ) => {
				console.error( err );
			} );
	};

	setTimeout( () => {
		authChecker();
	}, 1000 );
}

( function( $ ) {
	$( document ).ready( function() {
		const params = new URLSearchParams( window.location.search );
		if ( params.has( 'reset' ) ) {
			$( '.snapshot-tab-api-key' ).hide();
			$( '.snapshot-tab-configs' ).show();
			$( '.snapshot-page-main .current' ).removeClass( 'current' );
			$( '.snapshot-vertical-configs' ).addClass( 'current' );
		}
	} );
	function toggle_navbar_tabs( tab = 'api-key' ) {
		const tabEl = `.snapshot-tab-${ tab }`;
		const el = `.snapshot-vertical-${ tab }`;

		$( '.snapshot-page-main .snapshot-tab' ).hide();
		$( '.snapshot-page-main' ).find( '.sui-vertical-tab' ).removeClass( 'current' );

		$( '.snapshot-page-main' ).find( el ).addClass( 'current' );
		$( '.snapshot-page-main' ).find( tabEl ).show();
	}

	function copy_api_key() {
		$( '#snapshot-api-key' ).trigger( 'select' );
		document.execCommand( 'copy' );
		document.getSelection().removeAllRanges();
		jQuery( window ).trigger( 'snapshot:show_top_notice', [ 'success', snapshot_messages.api_key_copied, 3000, false ] );
	}

	function copy_site_id() {
		$( '#snapshot-site-id' ).trigger( 'select' );
		document.execCommand( 'copy' );
		document.getSelection().removeAllRanges();
		jQuery( window ).trigger( 'snapshot:show_top_notice', [ 'success', snapshot_messages.site_id_copied, 3000, false ] );
	}

	function reset_settings_confirm() {
		SUI.openModal( 'modal-settings-reset-settings', this );
		return false;
	}

	function delete_logs_confirm() {
		SUI.openModal( 'modal-snapshot-settings-delete-logs', this );
		return false;
	}

	function delete_logs() {
		const data = {
			_wpnonce: $( '#_wpnonce-delete_snapshot_logs' ).val(),
		};
		const url = ajaxurl + '?action=delete_snapshot_logs';

		$.ajax( {
			type: 'POST',
			url,
			data,
			cache: false,
			dataType: 'json',
			beforeSend() {
				$( '#modal-snapshot-settings-delete-logs .sui-button' ).prop( 'disabled', true );
			},
			complete() {
				$( '#modal-snapshot-settings-delete-logs .sui-button' ).prop( 'disabled', false );
				SUI.closeModal();
			},
			success( data ) {
				if ( data.success ) {
					openNotice( {
						message: snapshot_messages.delete_all_logs_success,
						type: 'success',
						dismissible: true
					} );
				} else {
					openNotice( {
						message: snapshot_messages.delete_all_logs_error,
						type: 'error',
						dismissible: true
					} );
				}
			},
			error() {
				openNotice( {
					message: snapshot_messages.delete_all_logs_error,
					type: 'error',
					dismissible: true
				} );
			}
		} );

		return false;
	}

	function reset_settings() {
		const data = {};

		data._wpnonce = $( '#_wpnonce-reset_snapshot_settings' ).val();

		const url = ajaxurl + '?action=reset_snapshot_settings';

		$.ajax( {
			type: 'POST',
			url,
			data,
			cache: false,
			dataType: 'json',
			beforeSend() {
				$( '#modal-settings-reset-settings .sui-button' ).prop( 'disabled', true );
				$( '.reset-loader' ).show();
				$( '#snapshot-settings-reset-settings>.sui-icon-undo' ).hide();
			},
			complete() {
				$( '#modal-settings-reset-settings .sui-button' ).prop( 'disabled', false );
				$( window ).trigger( 'snapshot:close_modal' );
			},
			success( data ) {
				if ( data.success ) {
					jQuery( window ).trigger( 'snapshot:show_top_notice', [ 'success', snapshot_messages.reset_settings_success, 3000, false ] );
					// Select "Keep" in Data & Settings => Uninstall
					$( '#snapshot-settings-save-tab-2 input[name=remove_on_uninstall][value=0]' ).trigger( 'click' );
					$( '#snapshot-remove-options-notice' ).hide();
					const currentUrl = new URL( window.location.href );
					currentUrl.searchParams.set( 'reset', 'done' );
					window.location.href = currentUrl.toString();
				} else {
					jQuery( window ).trigger( 'snapshot:show_top_notice', [ 'error', snapshot_messages.reset_settings_error ] );
				}
			},
			error() {
				jQuery( window ).trigger( 'snapshot:show_top_notice', [ 'error', snapshot_messages.reset_settings_error ] );
			}
		} );

		return false;
	}

	function save_settings() {
		const form = $( this );
		const data = {};
		form.serializeArray().forEach( function( item ) {
			data[ item.name ] = item.value;
		} );
		data._wpnonce = $( '#_wpnonce-save_snapshot_settings' ).val();

		const url = ajaxurl + '?action=save_snapshot_settings';

		$.ajax( {
			type: 'POST',
			url,
			data,
			cache: false,
			dataType: 'json',
			beforeSend() {
				form.find( '[type="submit"].sui-button' ).prop( 'disabled', true );
			},
			complete() {
				form.find( '[type="submit"].sui-button' ).prop( 'disabled', false );
			},
			success( data ) {
				if ( data.success ) {
					openNotice( {
						message: snapshot_messages.settings_save_success,
						type: 'success',
						autoclose: 3000,
					} );
				} else {
					openNotice( {
						message: snapshot_messages.settings_save_error,
						type: 'error',
						autoclose: 3000,
					} );
				}
			},
			error() {
				openNotice( {
					message: snapshot_messages.settings_save_error,
					type: 'error',
					autoclose: 3000
				} );
			}
		} );

		return false;
	}

	$( function() {
		if ( $( '.snapshot-page-settings' ).length ) {
			$( '.snapshot-page-main' ).on( 'click', '.sui-vertical-tab', function( e ) {
				e.preventDefault();
				const tab = $( this ).children( 'a' ).data( 'tab' );
				toggle_navbar_tabs( tab );
			} );

			$( '.snapshot-page-main .sui-mobile-nav' ).on( 'change', function() {
				const option = $( this ).val();
				toggle_navbar_tabs( option );
			} );

			$( '#snapshot-settings-copy-api-key' ).on( 'click', copy_api_key );
			$( '#snapshot-settings-copy-site-id' ).on( 'click', copy_site_id );

			$( '#snapshot-settings-delete-logs' ).on( 'click', delete_logs );

			$( '#snapshot-settings-reset-settings-confirm' ).on( 'click', reset_settings_confirm );
			$( '#snapshot-settings-reset-settings' ).on( 'click', reset_settings );

			$( '#snapshot-settings-save-tab-1' ).on( 'submit', save_settings );
			$( '#snapshot-settings-save-tab-2' ).on( 'submit', save_settings );

			if ( $( 'input[type=radio][name=remove_on_uninstall]:checked' ).val() === '1' ) {
				$( '#snapshot-remove-options-notice' ).show();
			}
			$( 'input[type=radio][name=remove_on_uninstall]' ).change( function() {
				if ( $( this ).val() === '0' ) {
					$( '#snapshot-remove-options-notice' ).hide();
				} else if ( $( this ).val() === '1' ) {
					$( '#snapshot-remove-options-notice' ).show();
				}
			} );
		}
	} );
}( jQuery ) );
